import React from 'react';
import DriverJobsScreen from '../screens/DriverJobsScreen';

const DriverNavigator: React.FC = () => <DriverJobsScreen />;

export default DriverNavigator;
